// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "environment/v1/environment.proto" (package "environment.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal and private environment RPCs and protos
//
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalEnvironmentService } from "./environment";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetEnvironmentResponse } from "./environment";
import type { GetEnvironmentRequest } from "./environment";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service environment.v1.InternalEnvironmentService
 */
export interface IInternalEnvironmentServiceClient {
    /**
     * Gets environment exposed from the app server
     *
     * @generated from protobuf rpc: GetEnvironment(environment.v1.GetEnvironmentRequest) returns (environment.v1.GetEnvironmentResponse);
     */
    getEnvironment(input: GetEnvironmentRequest, options?: RpcOptions): UnaryCall<GetEnvironmentRequest, GetEnvironmentResponse>;
}
/**
 * @generated from protobuf service environment.v1.InternalEnvironmentService
 */
export class InternalEnvironmentServiceClient implements IInternalEnvironmentServiceClient, ServiceInfo {
    typeName = InternalEnvironmentService.typeName;
    methods = InternalEnvironmentService.methods;
    options = InternalEnvironmentService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Gets environment exposed from the app server
     *
     * @generated from protobuf rpc: GetEnvironment(environment.v1.GetEnvironmentRequest) returns (environment.v1.GetEnvironmentResponse);
     */
    getEnvironment(input: GetEnvironmentRequest, options?: RpcOptions): UnaryCall<GetEnvironmentRequest, GetEnvironmentResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetEnvironmentRequest, GetEnvironmentResponse>("unary", this._transport, method, opt, input);
    }
}
